<template>
  <div class="flex-grid" @mousemove="mouseMove" style="position: relative">
    <Tooltip 
    :textObject="textForTooltip" 
    :top="tooltipPostion.y" 
    :left="tooltipPostion.x" 
    :hoverStatus="hoverIsOn" 
    :dataset="umapDataset"
    v-if="mouseIsOverUmap"
    />
    <div id="pan-nav">
      <p id="pan-intro">Pan UMAP w/</p>
      <div style="padding-top: 5px; text-align: center">
        <img src="../assets/images/wasd.svg" width=60 alt="">
      </div>
      <p style="font-style: italic; text-align: center">OR</p>
      <div class="pan-arrows">
        <div @click="moveCamera('up')" style="text-align: center">&#8593;</div>
        <div @click="moveCamera('left')" style="display: inline; float: left">&#8592;</div>
        <div @click="moveCamera('right')" style="display: inline; float: right">&#8594;</div>
        <br>
        <div @click="moveCamera('down')" style="text-align: center; display: block">&#8595;</div>
      </div>
      <div v-if="flatView" style="padding-left: 10px; margin-top: 10px">
        <button @click="handleZoomCamera('in', 'z')">
        <img class="zoom-icons" src="../assets/images/zoom_in.svg" alt="zoom in icon">
        </button>
        <button @click="handleZoomCamera('out', 'z')">
          <img class="zoom-icons" src="../assets/images/zoom_out.svg" alt="zoom out icon">
        </button>
      </div>
      <div v-else>
        <button @click="handleZoomCamera('in', 'y')">
        <img class="zoom-icons" src="../assets/images/zoom_in.svg" alt="zoom in icon">
        </button>
        <button @click="handleZoomCamera('out', 'y')">
          <img class="zoom-icons" src="../assets/images/zoom_out.svg" alt="zoom out icon">
        </button>
      </div>
    </div>

    <div class="column col-10" id="umap-container">
      <div id="selected-function" v-if="selectedFunctionFromSearch != null">
          <h4>Selected function:</h4>
          <h3>{{ lookupFunctionName(selectedFunctionFromSearch.dataset, selectedFunctionFromSearch.name) }} ({{selectedFunctionFromSearch.name}})</h3>
          <img width=100 :id="`image-`+selectedFunctionFromSearch.name" :src="selectedFunctionFromSearch.image" >
      </div>

    </div>
    <div class="column col-3 panel">
        <div style="font-size: 12px; font-style: italic; margin-top: -5px" v-if="dataForCard.Name != null">
          <span class="circle" style="background-color: #b35cc4"></span><span>highlighted in plot</span>
        </div>
        <div style="font-size: 14px; font-style: italic; margin-top: 5px; line-height: 1.4" v-else>
          <span>Click on a gene or function in the plot to view more information.</span>
        </div>
        
        <div v-if="dataForCard.Name != null">
          <h4><b>{{ dataForCard.type }}</b></h4>
          <div v-if="umapDataset == 'Durocher' && dataForCard.type == 'Function'">
            <h2 v-if="cardName != null">{{ lookupFunctionName('Durocher', cardName) }} ({{cardName}})</h2>  
          </div>
          <div v-else-if="umapDataset == 'Depmap' && dataForCard.type == 'Function'">
            <h2 v-if="cardName != null">{{ dataForCard["Manual Name"] }} ({{cardName}})</h2>  
          </div>
          <div v-else>
            <h2>{{ cardName }}</h2>
          </div>
          <div v-if="umapDataset == 'Durocher'">
            <div v-if="dataForCard.type == 'Gene'">
              <div class="function-list">
                <hr style="margin-bottom: 4px;">
                <div style="padding-left: 0px;" class="italic-legend">
                <p style="font-size: 14px, padding-top: 0px;">(ex: ### loading, function name)</p>
              </div>
                <div :class="{'activeFunctionLoading': dataForCard.activeFunction == dataForCard.Function_1}">
                  <h3>{{roundDecimal(dataForCard.Loading_1)}}</h3>
                  <h4>{{lookupFunctionName('Durocher', dataForCard.Function_1)}} ({{dataForCard.Function_1}})</h4>
                </div>
                <div  :class="{'activeFunctionLoading': dataForCard.activeFunction == dataForCard.Function_2}">
                  <h3>{{roundDecimal(dataForCard.Loading_2)}}</h3>
                  <h4>{{lookupFunctionName('Durocher', dataForCard.Function_2)}} ({{dataForCard.Function_2}})</h4>
                </div>
                <hr style="margin-bottom: 8px">
                <h3 style="font-size: 16px; font-weight: 700; padding-bottom: 4px;">Approximation quality (Pearson)</h3>
                <h3>{{roundDecimal(dataForCard.Recon_Pearson)}}</h3>
              </div>
            </div>
            <div v-else>
              <hr>
              <h4>Genotoxic stressors</h4>
              <h3>{{ dataForCard.Treatment_1}}</h3>
              <h3>{{ dataForCard.Treatment_2}}</h3>
            </div>
          </div>
          <!-- Depamp card details -->
          <div v-else>
            <div v-if="dataForCard.type == 'Gene'">
              <div class="function-list">
                <hr style="margin-bottom: 4px;">
                <div style="padding-left: 0px;" class="italic-legend">
                <p style="font-size: 14px">ex: ## loading, function name</p>
              </div>
                <div :class="{'activeFunctionLoading': dataForCard.activeFunction == dataForCard.Function_1}">
                  <h3>{{roundDecimal(dataForCard.Loading_1)}}</h3>
                  <h4>{{lookupFunctionName('Depmap', dataForCard.Function_1)}} ({{dataForCard.Function_1}})</h4>
                </div>
                <div :class="{'activeFunctionLoading': dataForCard.activeFunction == dataForCard.Function_2}">
                  <h3>{{roundDecimal(dataForCard.Loading_2)}}</h3>
                  <h4>{{lookupFunctionName('Depmap', dataForCard.Function_2)}} ({{dataForCard.Function_2}})</h4>
                </div>
                <div :class="{'activeFunctionLoading': dataForCard.activeFunction == dataForCard.Function_3}">
                  <h3>{{roundDecimal(dataForCard.Loading_3)}}</h3>
                  <h4>{{lookupFunctionName('Depmap', dataForCard.Function_3)}} ({{dataForCard.Function_3}})</h4>
                </div>
                <div :class="{'activeFunctionLoading': dataForCard.activeFunction == dataForCard.Function_4}">
                  <h3>{{roundDecimal(dataForCard.Loading_4)}}</h3>
                  <h4>{{lookupFunctionName('Depmap', dataForCard.Function_4)}} ({{dataForCard.Function_4}})</h4>
                </div>
                <hr style="margin-bottom: 8px">
                 <h3 style="font-size: 16px; font-weight: 700; padding-bottom: 4px;">Approximation quality (Pearson)</h3>
                <h3>{{roundDecimal(dataForCard.Recon_Pearson)}}</h3>
              </div>
            </div>
            <div class="depmap-info function-list" v-else>
              <hr>
              <h2 style="margin-bottom: 20px">Biomarkers</h2>
              <h3>{{dataForCard.biomarker.Feature_Name}}</h3>
              <h4>Feature Name</h4>
              <h3>{{dataForCard.biomarker.Type}}</h3>
              <h4>Type</h4>
              <h3>{{roundDecimal(dataForCard.biomarker.importance)}}</h3>
              <h4>Importance</h4>
              <h3>{{roundDecimal(dataForCard.biomarker.pearson)}}</h3>
              <h4>Pearson score</h4>
            </div>
          </div>
          <hr>
        </div>
    </div>
  </div>
</template>

<script>
import {ScatterGL} from '../../scatter-gl/dist/scatter_gl.js'; // local copy
import {interpolateNumber, tsv, scaleLinear} from 'd3';
import Tooltip from './Tooltip.vue'

export default {
  name: 'Umap',
  components: {
    Tooltip
  },
  data() {
    return {
      durocherDataset: null,
      durocherGeneToFunction: null,
      depmapDataset: null,
      depmapGeneToFunction: null,
      selectedUmapDataset: null,
      cardName: null,
      dataForCard: {},
      rotateStart: false,
      scatterGL: null,
      zoomSpeed: 0.4,
      vectorEmbedding: [],
      message: null,
      selectedIndex: null,
      selectedData: null,
      tooltipPostion: {x: 0, y:0},
      hoverIsOn: false,
      mouseIsOverUmap: false,
      depmapGeneTooltipData: null,
      depmapFunctionTooltipData: null,
      durocherGeneTooltipData: null,
      durocherFunctionTooltipData: null,
      durocherStdev: null,
      depmapStdev: null,
      depmapBiomarkers: null,
      textForTooltip: {
        Name: ""
      },
      currentCameraPosition: null,
      durocherFlatView: {
        x: 0.04221243905361019,
        y: 0.26466741373699093,
        z: -2.4539297792469936
      },
      durocherTopView: {
        x: 0.02188621218953115,
        y: 2.2533521758147677,
        z: -0.8843516622666177
      },
      depmapFlatView: {
        x: 0.042036877807717435,
        y: 0.15506729304934555,
        z: -2.3415134882848028
      },
      depmapTopView: {
        x: 0.01119154619243973,
        y: 1.865595393000226,
        z: -0.38376478273523495
      }
    }
  },
  props: {
    is3d: {
      default: false,
      type: Boolean
    },
    isOrbiting: {
      default: false,
      type: Boolean
    },
    flatView: {
      default: true,
      type: Boolean
    },
    interaction: {
      default: "pan",
      type: String
    },
    zVar: {
      type: String,
    },
    functionObject: {
      type: Object,
    },
    umapDataset: {
      type: String,
    },
    zoomLevel: {
      type: Object
    },
    highlightThisFromSearch: {
      type: Object
    },
    selectedFunctionFromSearch: {
      type: Object
    }
  },
  watch: {
    flatView() {
      if (this.is3d) {
        if (this.flatView == true) {
          this.transitionCamera("flat");
          setTimeout(()=>{ 
            this.calculateNewAxis();
          }, 1200);
          
        } else {
          this.transitionCamera("top");
          setTimeout(()=>{ 
            this.calculateNewAxis();
          }, 200);
        }
      }
    },
    zoomLevel() {
      if (this.flatView) {
        this.zoomCamera(this.zoomLevel, "z")
      } else  {
        this.zoomCamera(this.zoomLevel, "y")
      }
    },
    umapDataset(val) {
      if (val == "Durocher") {
        this.selectedUmapDataset = this.durocherDataset;
        this.updateScatterDataset();
      } else {
        this.selectedUmapDataset = this.depmapDataset;
        this.updateScatterDataset();
      }
      
      // clear data for card so it is empty when UMAP first loads
      this.dataForCard = {}
      this.cardName = ""
    },
    is3d() {
      if (this.is3d) {
        this.scatterGL.setDimensions(3)
      } else {
        this.scatterGL.setDimensions(2)
      }
    },
    rotateStart() {
      if (this.rotateStart) {
        this.scatterGL.startOrbitAnimation()
      } else {
        this.scatterGL.stopOrbitAnimation()
      }
    },
    interaction() {
      if (this.interaction == "pan") {
        this.scatterGL.setPanMode()
      } else if (this.interaction == "select") {
        this.scatterGL.setSelectMode()
      }
    },
    highlightThisFromSearch(val) {
      this.scatterGL.select([val.index])

      if (val.Name != undefined) {
        this.getDataForCard(val.index)
      } else {
        this.clearDataInCard()
      }
    },
    selectedFunctionFromSearch(val) {
      console.log("data for card is: ", this.dataForCard);

      // clear data for card so it is empty when UMAP first loads
      this.dataForCard = {}
    },
    zVar() {
      if (this.zVar == undefined) {
        console.log('zvar is undefined')
        this.calculateNewAxis()
      } else {
        this.calculateNewAxis()
      }
    }
  },
  created() {
    window.addEventListener('keydown', (e) => {
      switch (e.key) {
          case "w":
            this.moveCamera('up');
            break;
          case "d":
            this.moveCamera('right');
            break;
          case "s":
            this.moveCamera('down');
            break;
          case "a":
            this.moveCamera('left');
            break;
      }
    });
  },
  mounted() {
    const durocher1 = "https://broadinstitute.github.io/webster-umap-minisite/data/durocher_umap.tsv"
    const durocher2 = "https://broadinstitute.github.io/webster-umap-minisite/data/durocher_gene_to_function.tsv"
    const durocher3 = "https://broadinstitute.github.io/webster-umap-minisite/data/durocher_gene_to_function_stdev.tsv"
    const depmap1 = "https://broadinstitute.github.io/webster-umap-minisite/data/depmap_umap.tsv"
    const depmap2 = "https://broadinstitute.github.io/webster-umap-minisite/data/depmap_gene_to_function.tsv"
    const depmap3 = "https://broadinstitute.github.io/webster-umap-minisite/data/depmap_gene_to_function_stdev.tsv"
    // const depmap_biomarkers = "https://broadinstitute.github.io/webster-umap-minisite/data/depmap_fn_biomarkers.tsv"

    // load all external datasets
    Promise.all([
      tsv(durocher1, function(d) {
        return {
          Name: d.Name,
          X: +d.X,
          Y: +d.Y,
          Type: d.Type
        }
      }),
      tsv(durocher2, function(d) {
        return d;
      }),
      tsv(depmap1, function(d) {
        return {
          Name: d.Name,
          X: +d.X,
          Y: +d.Y,
          Type: d.Type
        }
      }),
      tsv(depmap2, function(d) {
        return d;
      }),
      tsv('https://broadinstitute.github.io/webster-umap-minisite/data/depmap_gene_meta.tsv', function(d) {
        return d;
      }),
      tsv('https://broadinstitute.github.io/webster-umap-minisite/data/depmap_fn_manual_name.tsv', function(d) {
        return d;
      }),
      tsv('https://broadinstitute.github.io/webster-umap-minisite/data/durocher_gene_meta.tsv', function(d) {
        return d;
      }),
      tsv('https://broadinstitute.github.io/webster-umap-minisite/data/durocher_fn_meta.tsv', function(d) {
        return d;
      }),
      tsv('https://broadinstitute.github.io/webster-umap-minisite/data/durocher_fn_display_name.tsv', function(d) {
        return d;
      }),
      tsv('https://broadinstitute.github.io/webster-umap-minisite/data/depmap_fn_manual_name.tsv', function(d) {
        return d;
      }),
      tsv(durocher3, function(d) {
        return d;
      }),
      tsv(depmap3, function(d) {
        return d;
      }),
    ]).then((dataset) => {
      this.durocherDataset = dataset[0]
      this.durocherGeneToFunction = dataset[1]
      this.depmapDataset = dataset[2]
      this.depmapGeneToFunction = dataset[3]
      this.depmapGeneTooltipData = dataset[4]
      this.depmapFunctionTooltipData = dataset[5]
      this.durocherGeneTooltipData = dataset[6]
      this.durocherFunctionTooltipData = dataset[7]
      this.durocherFunctionDisplay = dataset[8]
      this.depmapFunctionDisplay = dataset[9]
      this.durocherStdev = dataset[10]
      this.depmapStdev = dataset[11]

      // set the default dataset on mount / load
      if (this.umapDataset == "Durocher") {
        this.selectedUmapDataset = this.durocherDataset;
      } else {
        this.selectedUmapDataset = this.depmapDataset;
      }
      

      // format the data for umap
      const metadata = [];
      this.selectedUmapDataset.forEach((d,i) => {
        let entry = []

        d.tempZ = 0;

        // pushing the Y first in order to match orientation
        entry.push(d.X)
        entry.push(d.Y)

        // needs to have a range in order to plot, due to auto normalize
        // creating the appearance of a range so dots appear
        if (i == 0) {
          entry.push(1)
        } else {
          entry.push(0)
        }
        
        this.vectorEmbedding.push(entry)

        metadata.push({
          label: d.Name,
          Type: d.Type,
          index: i // maybe rredundant?
        });
      })

      // create a scatterGL dataset
      const datasetForScatter = new ScatterGL.Dataset(this.vectorEmbedding,  metadata);

      const containerElement = document.getElementById('umap-container');
      
      // set to true on load so it spins briefly before locking in place
      this.rotateStart = true;

      // listens for user interaction with the dots
      let lastSelectedPoints = [];

      let previousZ;
      let dotSize, selectedSize, hoverSize;

      console.log(this.umapDataset)

      if (this.umapDataset == "Durocher") {
        dotSize = 1;
        selectedSize =  1.4;
        hoverSize =  1.2;
      } else {
        dotSize = 0.2;
        selectedSize =  0.9;
        hoverSize =  0.3;
      }

      this.scatterGL = new ScatterGL(containerElement, {
        onCameraMove: (camera, target) => {
          // read position of camera
          // console.log("cam ", camera)
          // console.log("target", target)
          this.currentCameraPosition = camera;

          if (this.flatView) {
            if (camera.z > previousZ) {
              console.log('move in:', this.currentCameraPosition.z)
              if (this.umapDataset == "Durocher") {
                if (this.currentCameraPosition.z > -0.5) {
                  console.log('jump back')
                  this.preventZoomThrough(0.01);
                }
              } else {
                if (this.currentCameraPosition.z > -0.1) {
                  console.log('jump back')
                  this.preventZoomThrough(0.001);
                }
              }
              
            } else {
              console.log('move out')
            }
          }

          previousZ = camera.z;
        },
      renderMode: "POINT",
      showLabelsOnHover: false, // turning off b/c using custom tooltip on top of umap
      onSelect: (points) => {
        this.getDataForCard(points)
        
        // NOTE: clean up what you're not using
        if (points.length === 0 && lastSelectedPoints.length === 0) {
          this.message = 'no selection';
        } else if (points.length === 0 && lastSelectedPoints.length > 0) {
          this.message = 'deselected';
        } else if (points.length === 1) {
          this.message = `selected ${points}`;
          this.selectedIndex = points;
          this.getSelectedDataPoint(this.selectedIndex)
        } else {
          this.message = `selected ${points.length} points`;
        }
    },
    onHover: (point) => {
      
      if (point != null) {
        if (this.mouseIsOverUmap) {
          this.hoverIsOn = true;
          this.getDataForTooltip(point)
        } else {
          this.hoverIsOn = false;
        }
      } else {
          // turn off tooltip if hovering on UMAP but not on a point
          this.hoverIsOn = false;
      }
    },
      rotateOnStart: this.rotateStart,
      orbitControls: {
        zoomSpeed: this.zoomSpeed
      },
      styles: {
        axesVisible: false,
        fog: {
          enabled: true,
          color: '#ffffff',
          threshold: 80000
        },
        point: {
          colorUnselected: 'rgba(120, 120, 120, 0.7)',
          colorNoSelection: 'rgba(51, 51, 51, 0.7)',
          colorSelected: '#b35cc4',
          colorHover: 'rgba(221, 82, 158, 0.8)',
          scaleDefault: dotSize,
          scaleSelected: selectedSize,
          scaleHover: hoverSize
        }
      }
    })

    this.scatterGL.setDimensions(this.is3D ? 3 : 2);

    // TODO: set the colors as a Vue variable
    this.scatterGL.setPointColorer((i) => {
      if (metadata[i].Type == "Function") {
        return 'black'
      } else {
        return 'rgba(194, 194, 194, 0.5)'
      }
    })

    this.scatterGL.render(datasetForScatter);

    setTimeout(()=>{ 
      this.scatterGL.stopOrbitAnimation();
      this.transitionCamera("flat");
      }, 500);
    })
  },
  methods: {
    preventZoomThrough(val) {
      this.scatterGL.scatterPlot.setCameraPositionAndTarget(
        [this.scatterGL.scatterPlot.getCameraPosition()[0], 
        this.scatterGL.scatterPlot.getCameraPosition()[1], 
        this.scatterGL.scatterPlot.getCameraPosition()[2]-val],
        [this.scatterGL.scatterPlot.getCameraTarget()[0],
        this.scatterGL.scatterPlot.getCameraTarget()[1],
        this.scatterGL.scatterPlot.getCameraTarget()[2]]
      )
    },
    handleZoomCamera(direction, axis) {
      let d = {direction: direction};

      this.zoomCamera(d, axis)
    },
    moveCamera(dir) {
      let zoomMultiplier;
      if ((this.currentCameraPosition.z > -1) && (this.currentCameraPosition.z <= -0.5)) {
        zoomMultiplier = 0.5
      } else if ((this.currentCameraPosition.z > -0.499) && (this.currentCameraPosition.z <= -0.25)) {
        zoomMultiplier = 0.25
      } else if ((this.currentCameraPosition.z > -0.2499) && (this.currentCameraPosition.z <= -0.1)) {
        zoomMultiplier = 0.10
      } else {
        zoomMultiplier = 1;
      }

      let zoomFactor = 0.02 * zoomMultiplier;
      let i = 0;
      let absoluteTarget = [0,0,0];
      
      if (this.flatView) {
        if (dir == "up") {
          this.scatterGL.scatterPlot.setCameraPositionAndTarget(
            [this.scatterGL.scatterPlot.getCameraPosition()[0], 
            this.scatterGL.scatterPlot.getCameraPosition()[1]+zoomFactor, 
            this.scatterGL.scatterPlot.getCameraPosition()[2]],
            [this.scatterGL.scatterPlot.getCameraTarget()[0],
            this.scatterGL.scatterPlot.getCameraTarget()[1]+zoomFactor,
            this.scatterGL.scatterPlot.getCameraTarget()[2]])
        } else if (dir == "down") {
          this.scatterGL.scatterPlot.setCameraPositionAndTarget(
            [this.scatterGL.scatterPlot.getCameraPosition()[0], 
            this.scatterGL.scatterPlot.getCameraPosition()[1]-zoomFactor, 
            this.scatterGL.scatterPlot.getCameraPosition()[2]],
            [this.scatterGL.scatterPlot.getCameraTarget()[0],
            this.scatterGL.scatterPlot.getCameraTarget()[1]-zoomFactor,
            this.scatterGL.scatterPlot.getCameraTarget()[2]])
        }  else if ((dir == "left")) {
          this.scatterGL.scatterPlot.setCameraPositionAndTarget(
              [this.scatterGL.scatterPlot.getCameraPosition()[0]+zoomFactor, 
              this.scatterGL.scatterPlot.getCameraPosition()[1], 
              this.scatterGL.scatterPlot.getCameraPosition()[2]],
              [this.scatterGL.scatterPlot.getCameraTarget()[0]+zoomFactor,
              this.scatterGL.scatterPlot.getCameraTarget()[1],
              this.scatterGL.scatterPlot.getCameraTarget()[2]])
        } else {
          this.scatterGL.scatterPlot.setCameraPositionAndTarget(
              [this.scatterGL.scatterPlot.getCameraPosition()[0]-zoomFactor, 
              this.scatterGL.scatterPlot.getCameraPosition()[1], 
              this.scatterGL.scatterPlot.getCameraPosition()[2]],
              [this.scatterGL.scatterPlot.getCameraTarget()[0]-zoomFactor,
              this.scatterGL.scatterPlot.getCameraTarget()[1],
              this.scatterGL.scatterPlot.getCameraTarget()[2]])
        }
      } else {
        if (dir == "up") {
          this.scatterGL.scatterPlot.setCameraPositionAndTarget(
            [this.scatterGL.scatterPlot.getCameraPosition()[0], 
            this.scatterGL.scatterPlot.getCameraPosition()[1], 
            this.scatterGL.scatterPlot.getCameraPosition()[2]+zoomFactor],
            [this.scatterGL.scatterPlot.getCameraTarget()[0],
            this.scatterGL.scatterPlot.getCameraTarget()[1],
            this.scatterGL.scatterPlot.getCameraTarget()[2]+zoomFactor])
        } else if (dir == "down") {
          this.scatterGL.scatterPlot.setCameraPositionAndTarget(
            [this.scatterGL.scatterPlot.getCameraPosition()[0], 
            this.scatterGL.scatterPlot.getCameraPosition()[1], 
            this.scatterGL.scatterPlot.getCameraPosition()[2]-zoomFactor],
            [this.scatterGL.scatterPlot.getCameraTarget()[0],
            this.scatterGL.scatterPlot.getCameraTarget()[1],
            this.scatterGL.scatterPlot.getCameraTarget()[2]-zoomFactor])
        }  else if ((dir == "left")) {
          this.scatterGL.scatterPlot.setCameraPositionAndTarget(
              [this.scatterGL.scatterPlot.getCameraPosition()[0]+zoomFactor, 
              this.scatterGL.scatterPlot.getCameraPosition()[1], 
              this.scatterGL.scatterPlot.getCameraPosition()[2]],
              [this.scatterGL.scatterPlot.getCameraTarget()[0]+zoomFactor,
              this.scatterGL.scatterPlot.getCameraTarget()[1],
              this.scatterGL.scatterPlot.getCameraTarget()[2]])
        } else {
          this.scatterGL.scatterPlot.setCameraPositionAndTarget(
              [this.scatterGL.scatterPlot.getCameraPosition()[0]-zoomFactor, 
              this.scatterGL.scatterPlot.getCameraPosition()[1], 
              this.scatterGL.scatterPlot.getCameraPosition()[2]],
              [this.scatterGL.scatterPlot.getCameraTarget()[0]-zoomFactor,
              this.scatterGL.scatterPlot.getCameraTarget()[1],
              this.scatterGL.scatterPlot.getCameraTarget()[2]])
        }
      }
    },
    roundDecimal(val) {
      if (val == undefined) {
        return ''
      } else {
        const num = (val/1).toFixed(2)
        return num.toString()
      }
    },
    lookupFunctionName(dataset, fn) {
      let displayName;
      if (fn == undefined) {
        displayName = ''
      } else {
        if (dataset == "Durocher") {
          let name = this.durocherFunctionDisplay.find(element => element.Name == fn);
          displayName = name.Display_Name;
        } else {
          let name = this.depmapFunctionDisplay.find(element => element.Name == fn);
          displayName = name["Manual Name"];
        }
      }

      return displayName
    },
    calculateNewAxis() {
        let metadata = [];
        let allZValues = [];
        let allYValues = [];
        let allXValues = [];
        this.vectorEmbedding = [];

        let geneToFunction;

        if (this.umapDataset == "Durocher") {
          geneToFunction = this.durocherGeneToFunction;
        } else {
          geneToFunction = this.depmapGeneToFunction;
        }

        this.selectedUmapDataset.forEach((d, i) => {
          let zValue;
          let entry = [];

          if (d.Type == "Gene") {
            // find the object for this gene
            let item = geneToFunction.find(element => element.Name == d.Name);
            
            // pull out the value for the selected function
            zValue = item[this.zVar]

            // store so we can get the min/max of range
            allZValues.push(zValue)
          } else {
            zValue = 0
          }
          
          entry.push(d.X)
          allYValues.push(d.X)

          entry.push(d.Y)
          allXValues.push(d.Y)

          if (this.flatView) {
            if (i == 0) {
              entry.push(1)
            } else {
              entry.push(0)
            }
          } else {
            entry.push(zValue)
          }

          
          this.vectorEmbedding.push(entry)

          metadata.push({
            label: d.Name,
            type: d.Type,
            index: i,
            zValue: zValue
          });
        })

        const maxZVal = Math.max(...allZValues);
        const minZVal = Math.min(...allZValues);

        function getAvg(arr) {
          let total = 0;
          for(var i = 0; i < arr.length; i++) {
              total += arr[i];
          }
          return total / arr.length;
        }

        if (this.umapDataset == "Depmap") {
          this.vectorEmbedding.push([getAvg(allYValues), getAvg(allXValues), maxZVal])
          metadata.push({
              label: "ghost",
              type: "ghost"
          })
        }

        const positiveColorScale = scaleLinear()
            .domain([0, maxZVal])
            .range(["#91e0f2", "#008cb7"])

        const negativeColorScale = scaleLinear()
            .domain([0, minZVal])
            .range(["#f2ae9c", "#ef2c0c"])

        this.scatterGL.setPointColorer((i) => {
              if (metadata[i].type == "Function") {
                return 'black'
              } else if (metadata[i].zValue > 0) {
                return positiveColorScale(metadata[i].zValue)
              } else if (metadata[i].zValue < 0) {
                return negativeColorScale(metadata[i].zValue)
              } else if (metadata[i].type == "ghost") {
                return 'rgba(194, 194, 194, 0.0)' // trasnparent ghost point
              } else {
                return 'rgba(194, 194, 194, 0.4)'
              }
          })

          this.scatterGL.updateDataset(new ScatterGL.Dataset(this.vectorEmbedding, metadata))
        
    },
    mouseMove(event) {
      if (event.target.tagName == "CANVAS") {
        this.mouseIsOverUmap = true
      } else {
        this.mouseIsOverUmap = false
      }

      this.tooltipPostion.x = event.offsetX;
      this.tooltipPostion.y = event.offsetY
    },
    updateScatterDataset() {
      // TODO: use this in mounted() to make more generalizable
        let metadata = [];
        let vectorEmbedding = [];
        this.selectedUmapDataset.forEach((d,i) => {
          let entry = []

          d.tempZ = 0;

          entry.push(d.Y)
          entry.push(d.X)
          if (i == 0) {
            entry.push(1)
          } else {
            entry.push(0)
          }

          vectorEmbedding.push(entry)

          metadata.push({
            label: d.Name,
            Type: d.Type,
            index: i
          });
        })

        const datasetForScatter = new ScatterGL.Dataset(vectorEmbedding,  metadata)
      
        this.scatterGL.setDimensions(this.is3D ? 3 : 2);

        // when durocher, this needs to happen before coloring
        if (this.umapDataset == "Durocher") {
          this.scatterGL.updateDataset(datasetForScatter);
        }
        
        this.scatterGL.setPointColorer((i) => {
                if (metadata[i].Type == "Function") {
                  return 'black'
                } else {
                  return 'rgba(194, 194, 194, 0.4)'
                }
        })

        // but when depmap, it neeeds to happen after...not sure why tbh?
        if (this.umapDataset == "Depmap") {
          this.scatterGL.updateDataset(datasetForScatter);
        }
        
        this.scatterGL.scatterPlot.setCameraPositionAndTarget(
          [this.durocherFlatView.x, this.durocherFlatView.y, this.durocherFlatView.z],
          [0,0,0]
        );

          this.transitionCamera("flat")
    },
    clearDataInCard() {
      this.dataForCard.Name = null;
    },
    getDataForCard(point) {
      this.cardName = this.selectedUmapDataset[point].Name;

      // TODO: move this Promise statement to a single-call function, page load maybe
      Promise.all([
      tsv("https://broadinstitute.github.io/webster-umap-minisite/data/durocher_gene_meta.tsv", function(d) {
        return d
      }),
      tsv("https://broadinstitute.github.io/webster-umap-minisite/data/durocher_fn_meta.tsv", function(d) {
        return d
      }),
      tsv("https://broadinstitute.github.io/webster-umap-minisite/data/depmap_gene_meta.tsv", function(d) {
        return d
      }),
      tsv("https://broadinstitute.github.io/webster-umap-minisite/data/depmap_fn_manual_name.tsv", function(d) {
        return d
      }),
      tsv("https://broadinstitute.github.io/webster-umap-minisite/data/depmap_fn_annot_gprofiler.tsv", function(d) {
        return d
      }),
      tsv("https://broadinstitute.github.io/webster-umap-minisite/data/depmap_fn_biomarkers.tsv", function(d) {
        return d;
      })
    ]).then((dataset) => {
      
      let data, item;

      // TODO: convert these into two functions, one for gene and one for function to reduce redundancy
      // NOTE: try indexing the data (i.e. turn it into a dictionary) by element name instead of doing a find lookup each time
      // could I use Set instead? more performant?
      if (this.umapDataset == "Durocher") {
        if (this.selectedUmapDataset[point].Type == "Gene") {
          data = dataset[0];
          item = data.find(element => element.Name == this.selectedUmapDataset[point].Name);
          
          let loadings = this.durocherStdev.find(element => element.Name == this.selectedUmapDataset[point].Name);
          let loadingScore = loadings[this.zVar]
          item.loadingValue = loadingScore;

          if ((this.zVar == item.Function_1)) {
            item.activeFunction = item.Function_1
          } else if (this.zVar == item.Function_2) {
            item.activeFunction = item.Function_2
          } else {
            item.activeFunction = undefined
          }
          item.type = "Gene"
        } else {
          data = dataset[1];
          let name = this.durocherFunctionDisplay.find(element => element.Name == this.selectedUmapDataset[point].Name);
          item = data.find(element => element.Name == name.Name);
          item.type = "Function"
        }
      } else {
        if (this.selectedUmapDataset[point].Type == "Gene") {
          data = dataset[2];
          item = data.find(element => element.Name == this.selectedUmapDataset[point].Name);
          let loadings = this.depmapStdev.find(element => element.Name == this.selectedUmapDataset[point].Name);
          let loadingScore = loadings[this.zVar]
          item.loadingValue = loadingScore
          this.textForTooltip.value = this.roundDecimal(loadingScore)
          if ((this.zVar == item.Function_1)) {
            item.activeFunction = item.Function_1
          } else if (this.zVar == item.Function_2) {
            item.activeFunction = item.Function_2
          } else if (this.zVar == item.Function_3) {
            item.activeFunction = item.Function_3
          } else if (this.zVar == item.Function_4) {
            item.activeFunction = item.Function_4
          } else {
            item.activeFunction = undefined
          }
          item.type = "Gene"
        } else {
          this.depmapBiomarkers = dataset[5]

          // find function from dataset, use manual name
          data = dataset[3];
          let depmapMetaInfo = dataset[4];
          let name = data.find(element => element.Name == this.selectedUmapDataset[point].Name);
          let biomarkerData = this.depmapBiomarkers.find(d => d.Name == this.selectedUmapDataset[point].Name);

          item = data.find(element => element.Name == name.Name);
          item.meta = depmapMetaInfo.find(element => element.Name == item.Name);
          item.biomarker = biomarkerData;

          // trim at 5 max genes to display
          item.top_genes = item.meta.Loaded_Genes.split(" ").splice(0,5);
          
          item.type = "Function";
          console.log(item)
        }
      }

      console.log('data for card:', item)
      
      this.dataForCard = item;
    })
      
    },
    getDataForTooltip(point) {
      // TODO: get rid of everything that is not the name
      this.textForTooltip.Name = this.selectedUmapDataset[point].Name;
      
      let item;
      if (this.umapDataset == "Depmap") {
        if (this.selectedUmapDataset[point].Type == "Gene") {
          item = this.depmapGeneTooltipData.find(element => element.Name == this.textForTooltip.Name);
          let loadings = this.depmapStdev.find(element => element.Name == this.textForTooltip.Name);
          let loadingScore = loadings[this.zVar]
          this.textForTooltip.value = this.roundDecimal(loadingScore)
          this.textForTooltip.type = "gene"
        } else if (this.selectedUmapDataset[point].Type == "Function") {
          item = this.depmapFunctionTooltipData.find(el => el.Name == this.textForTooltip.Name);
          let name = this.depmapFunctionDisplay.find(element => element.Name == this.selectedUmapDataset[point].Name);
          this.textForTooltip.display_name = this.lookupFunctionName('Depmap', this.textForTooltip.Name)
          console.log('2nd, ', this.lookupFunctionName('Depmap', this.textForTooltip.Name))
          this.textForTooltip.type = "fn"
        } else {
          console.log('error!')
        }
      } else {
        if (this.selectedUmapDataset[point].Type == "Gene") {
          item = this.durocherGeneTooltipData.find(element => element.Name == this.textForTooltip.Name);
          let loadings = this.durocherStdev.find(element => element.Name == this.textForTooltip.Name);
          let loadingScore = loadings[this.zVar]
          this.textForTooltip.value = this.roundDecimal(loadingScore)
          this.textForTooltip.type = "gene"
        } else if (this.selectedUmapDataset[point].Type == "Function") {
          let name = this.durocherFunctionDisplay.find(element => element.Name == this.textForTooltip.Name)
          item = this.durocherFunctionTooltipData.find(element => element.Name == name.Name);
          this.textForTooltip.display_name = this.lookupFunctionName('Durocher', this.textForTooltip.Name)
          
          this.textForTooltip.type = "fn"
        } else {
          console.log('error!')
        }
      }
    },
    zoomCamera(d, axis) {
      // TODO: refactor make more generalizable
      let zoomFactor = Math.pow( 0.05, this.zoomSpeed );

      if (axis == "z") {
        if (d.direction == "in") {
          
          // for both datasets, reset zoom view if user zooms past a certain point
          // in order to prevent moving "through" the umap
          if (this.umapDataset == "Durocher") {
            console.log(this.scatterGL.scatterPlot.getCameraPosition()[2])
            if (this.scatterGL.scatterPlot.getCameraPosition()[2] > -0.5) {
            this.preventZoomThrough(0.1);
            } else {
              this.scatterGL.scatterPlot.setCameraPositionAndTarget(
                [this.scatterGL.scatterPlot.getCameraPosition()[0], 
                this.scatterGL.scatterPlot.getCameraPosition()[1], 
                this.scatterGL.scatterPlot.getCameraPosition()[2]+zoomFactor],
                [this.scatterGL.scatterPlot.getCameraTarget()[0],
                this.scatterGL.scatterPlot.getCameraTarget()[1],
                this.scatterGL.scatterPlot.getCameraTarget()[2]]
              );
            }
          } else {
            console.log(this.scatterGL.scatterPlot.getCameraPosition()[2])
            if (this.scatterGL.scatterPlot.getCameraPosition()[2] > -0.25) {
              this.preventZoomThrough(0.005);
            } else {
              this.scatterGL.scatterPlot.setCameraPositionAndTarget(
                [this.scatterGL.scatterPlot.getCameraPosition()[0], 
                this.scatterGL.scatterPlot.getCameraPosition()[1], 
                this.scatterGL.scatterPlot.getCameraPosition()[2]+(zoomFactor/3)],
                [this.scatterGL.scatterPlot.getCameraTarget()[0],
                this.scatterGL.scatterPlot.getCameraTarget()[1],
                this.scatterGL.scatterPlot.getCameraTarget()[2]]
              );
            }
          }
      } else if (d.direction == "out") {
        this.scatterGL.scatterPlot.setCameraPositionAndTarget(
          [this.scatterGL.scatterPlot.getCameraPosition()[0], 
          this.scatterGL.scatterPlot.getCameraPosition()[1], 
          this.scatterGL.scatterPlot.getCameraPosition()[2]-zoomFactor],
          [this.scatterGL.scatterPlot.getCameraTarget()[0],
          this.scatterGL.scatterPlot.getCameraTarget()[1],
          this.scatterGL.scatterPlot.getCameraTarget()[2]]
        );
      }
      } else if (axis == "y") {
        if (d.direction == "in") {
        this.scatterGL.scatterPlot.setCameraPositionAndTarget(
          [this.scatterGL.scatterPlot.getCameraPosition()[0], 
          this.scatterGL.scatterPlot.getCameraPosition()[1]-zoomFactor, 
          this.scatterGL.scatterPlot.getCameraPosition()[2]],
          [this.scatterGL.scatterPlot.getCameraTarget()[0],
          this.scatterGL.scatterPlot.getCameraTarget()[1],
          this.scatterGL.scatterPlot.getCameraTarget()[2]]
        );
      } else if (d.direction == "out") {
        this.scatterGL.scatterPlot.setCameraPositionAndTarget(
          [this.scatterGL.scatterPlot.getCameraPosition()[0], 
          this.scatterGL.scatterPlot.getCameraPosition()[1]+zoomFactor, 
          this.scatterGL.scatterPlot.getCameraPosition()[2]],
          [this.scatterGL.scatterPlot.getCameraTarget()[0],
          this.scatterGL.scatterPlot.getCameraTarget()[1],
          this.scatterGL.scatterPlot.getCameraTarget()[2]]
        );
      }
      }
      
    },
    transitionCamera(view) {

      let angle;

      if (view == "top") {
        if (this.umapDataset == "Durocher") {
          angle = this.durocherTopView
        } else {
          angle = this.depmapTopView
        }
      } else if (view == "flat") {
        if (this.umapDataset == "Durocher") {
          angle = this.durocherFlatView
        } else {
          angle = this.depmapFlatView
        }
      }
      
      let interpolatorX = interpolateNumber(this.scatterGL.scatterPlot.getCameraPosition()[0], angle.x)
      let interpolatorY = interpolateNumber(this.scatterGL.scatterPlot.getCameraPosition()[1], angle.y)
      let interpolatorZ = interpolateNumber(this.scatterGL.scatterPlot.getCameraPosition()[2], angle.z)
      
      const iterator = 350;
      for (let i=0; i<iterator; i=i+1) {
          // set the delay in ms for how quickly the camera is updated
          setTimeout(() => { 
            // this.scatterGL.scatterPlot.setCameraPositionAndTarget([this.flatViewCoords.x, this.flatViewCoords.y+(i/100), this.flatViewCoords.z+(i/200)], [0, 0, 0]);
            this.scatterGL.scatterPlot.setCameraPositionAndTarget([
              interpolatorX(i/iterator),
              interpolatorY(i/iterator),
              interpolatorZ(i/iterator)
            ],
              [0, 0, 0]); // target
          }, 300); // wait for z-axis data to be finished updating
        }
    },
    getSelectedDataPoint(selectedIndex) {
      this.selectedData = this.vectorEmbedding[selectedIndex]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #umap-container {
    height: 480px
  }

  .activeFunctionLoading * {
    font-weight: 600 !important;
  }

  .activeFunctionLoading {
    font-weight: inherit;
    position: relative;
    border: 1px solid black;
    background-color: rgb(228, 228, 228);
    padding: 5px
  }

  hr {
    border: none;
    background-color: black;
    height: 1px;

  }

  .italic-legend {
    font-style: italic;
    font-size: 12px;
    line-height: 1.0
  }

  
  .function-list h4 {
    line-height: 1.0;
    padding-bottom: 10px
  }

  .function-list h3 {
    font-weight: 300;
    font-size: 18px;
    line-height: 1.0
  }

  .function-list div {
    padding: 5px
  }

  .panel {
    border: 1px solid gray;
    margin: 10px;
    padding: 20px
  }

  .annotations-list {
    margin-top: 20px
  }

  p{
  margin-bottom: 0px;
  border:0px;
}

h2{
  margin: 0px;
  margin-top: 2px;
  line-height: 20px;
}

h3{
  margin-top: 0px;
  margin-bottom: 1px;
}

h4{
  margin-top: 6px;
}

#selected-function {
  position: absolute; 
  left: 20px; 
  top: 10px;
  width: 200px;
  height: auto;
}

#selected-function h4 {
  font-weight: 500;
  margin-bottom: 4px;
}

#selected-function img {
  border: 1px solid gray;
  width: 130px;
  height: 130px
}

#pan-nav {
  position: absolute; 
  left: 20px; 
  bottom: 10px;
  width: 85px;
  height: 230px;
  font-weight: 600;
  cursor: pointer;
  padding: 10px;
  background-color: rgb(254, 254, 254);
  border-radius: 10px;
  box-shadow: 0px 0px 4px #00000029;
}

#pan-nav button {
  margin: 0px;
  background-color: white;
  border: none;
  cursor: pointer;
}

.circle {
  border-radius: 50%;
  display: inline-block;
  height: 10px;
  width: 10px;
  margin-right: 5px
}

#pan-nav button:hover {
  background-color: rgb(232, 232, 232);
}

.zoom-icons {
  border: none;
  width: 15px;
}

.pan-arrows div:hover {
  background-color: rgb(232, 232, 232);
}

#pan-intro {
  font-size: 14px;
  font-style: italic;
  line-height: 1;
  padding: 0px;
  margin-bottom: 8px
}
</style>
